<template>
  <div class="companySetting" style="border:1px solid #e0e0e0;">
    <div class="titleForm-container">公司设置</div>
    <div class="content-form-container">
      <div class="main-container-form">
        <el-form :model="baseForm" :rules="rules" ref="baseForm" label-width="100px" class="ruleForm">
          <el-form-item label="公司logo" prop="images" class="imgLogo">
            <el-upload
              class="avatar-uploader"
              :disabled="!edit"
              :action="uploadURl"
              :with-credentials="true"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
             <img  :src="imageUrl" class="avatar" v-if="imageUrl !=''">
               <img  src="../../../../assets/images/icon_company@2x.png" class="avatar" v-else>
              <!-- <img  v-else src="../../../assets/images/icon_company@2x.png" class="avatar" > -->
              <span size="small" type="primary" >重新上传</span>
            </el-upload>
          </el-form-item>
         
          <el-form-item label="公司名称" prop="enterpriseName">
            <el-input v-model="baseForm.enterpriseName" :disabled="!edit||baseForm.enterpriseID==1397272" size="medium" style="width:100%;" placeholder="请输入公司全称" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num50">
            </el-input>
          </el-form-item>
          <el-form-item label="公司简称" prop="enterpriseShortName">
            <el-input v-model="baseForm.enterpriseShortName" :disabled="!edit" size="medium" style="width:100%;" placeholder="请输入真实姓名" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num20">
            </el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="leader">
            <el-input v-model="baseForm.leader" disabled size="medium" style="width:100%;" placeholder="请输入真实姓名" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num20">
            </el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="baseForm.phone" disabled size="medium" style="width:100%;" placeholder="请输入有效联系电话" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num11">
            </el-input>
          </el-form-item>
           <el-row :gutter="5">
            <el-form-item label="公司地址" required>
              <el-col :span="8">
                <el-form-item prop="provinceNo">
                  <el-select v-model="baseForm.provinceNo" filterable :disabled="!edit" placeholder="请选择省份" size="medium" style="width:100%;" @change="selectProvince" >
                    <el-option v-for="item in provinces" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="cityNo"  v-if="citys.length>0">
                  <el-select v-model="baseForm.cityNo" filterable :disabled="!edit" placeholder="请选择市" size="medium" style="width:100%;" @change="selectCity">
                    <el-option v-for="item in citys" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="countyNo"  v-if="countys.length>0">
                  <el-select v-model="baseForm.countyNo" filterable :disabled="!edit" placeholder="请选择县" size="medium" style="width:100%;">
                    <el-option v-for="item in countys" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-row>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model="baseForm.address" :disabled="!edit" size="medium" style="width:100%;" type="text" :maxlength="num50" placeholder="详细地址不得少于2个字符" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
          </el-form-item>
         
          <el-form-item label="营业执照" prop="licensePhoto">
            <el-upload
              
              style="width:1200px;"
              :action="uploadURl1"
              list-type="picture-card"
              :file-list="fileList"
              :with-credentials="true"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :on-change="handleChange"
              :class="{hide:isShow}" 
              :on-remove="handleRemove">
              <i class="el-icon-plus">
                <h4 class="upload-tip">最多上传一张jpg/png图片，且不超过500kb</h4>
              </i>
            </el-upload>
            
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>
          <el-form-item label="公司图片" prop="enterpriseImgList">
            <el-upload
              style="width:1200px;"
              :class="{hide:hideUpload}"
              :on-change="handleChange1" 
              :action="uploadURl2"
              list-type="picture-card"
              :file-list="fileList1"
              :with-credentials="true"
              :before-upload="beforeUpload1"
              :on-success="handleSuccess1"
              :on-remove="handleRemove1">
              <i class="el-icon-plus">
                <h4 class="upload-tip">最多上传四张jpg/png图片，且不超过500kb</h4>
              </i>
            </el-upload>
            
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>
          <el-form-item label="公司简介" prop="remark">
            <el-input
              :disabled="!edit"
              type="textarea"
              autosize
              placeholder="请输入公司简介，不得超过200字"
              v-model="baseForm.remark">
            </el-input>
          </el-form-item>
          <el-form-item label="经营范围" prop="scope">
            <el-input
              :disabled="!edit"
              type="textarea"
              autosize
              placeholder="请输入主营范围，不得超过200字"
              v-model="baseForm.scope">
            </el-input>
          </el-form-item>
         
          
          <el-form-item class="save-cancel">
            <el-col :span="8">
              <el-button class="cancel-btn" @click="cancelForm('baseForm')" v-if="edit">取消</el-button>
            </el-col>
            <el-col :span="8">
              <el-button class="save-btn" @click="saveData('baseForm')" :loading="loadingtype" v-if="edit">保存</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import imgUpload from "../../../../service/base-url";
import { modules } from "../../../../store";
import checkPermission from "../../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "companySetting",
  mixins: [mixins],
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      isShow: false,
      hideUpload: false,
      loadingtype: false,
      imageUrl: "",
      uploadURl: imgUpload.imgUpload, // 文件上传地址
      uploadURl1: imgUpload.imgUpload, // 文件上传地址
      uploadURl2: imgUpload.imgUpload, // 文件上传地址
      fileList: [],
      fileList1: [],
      num20: 20,
      num11: 11,
      num50: 50,
      citys: [],
      countys: [],
      index: "",
      // 参数
      baseForm: {
        enterpriseID: "",
        enterpriseName: "",
        enterpriseShortName: "",
        leader: "", // 联系人
        phone: "",
        provinceNo: "", // 省份
        cityNo: "", // 城市
        countyNo: "", // 辖区
        address: "", // 详细地址
        imageName: "",
        remark: "",
        scope: "", //经营范围
        licensePhoto: [], //营业执照
        enterpriseImgList: [] //公司图片
      },
      // 校验规则
      rules: {
        enterpriseName: [
          {
            required: true,
            message: "请先输入公司全称",
            trigger: "blur"
          },
          {
            pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
            message: "公司名称格式不对,请重新输入"
          }
        ],
        enterpriseShortName: [
          {
            required: true,
            message: "请先输入公司简称",
            trigger: "blur"
          },
          {
            pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
            message: "公司简称格式不对,请重新输入"
          }
        ],
        leader: [
          // { required: true, message: "请先输入真实姓名", trigger: "blur" },
          // {
          //   pattern: /^[a-zA-Z\u4e00-\u9fa5]+$/,
          //   message: "真实姓名格式不对,请重新输入"
          // }
        ],
        phone: [
          { required: true, message: "请先填写联系电话" },
          {
            pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,
            message: "联系电话格式不对,请重新输入"
          }
        ],
        provinceNo: [
          { required: true, message: "请先选择省份", trigger: "change" }
        ],
        cityNo: [{ required: true, message: "请先选择市", trigger: "change" }],
        countyNo: [
          { required: true, message: "请先选择县", trigger: "change" }
        ],
        address: [
          { required: true, message: "请先输入详细地址", trigger: "blur" }
          // {
          //   pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
          //   message: "详细地址格式不对,请重新输入",
          //   min: 2
          // }
        ]
      }
    };
  },
  mounted() {
    this.getProvinces();
    this.getData();
  },
  computed: {
    ...mapState(modules.area, {
      provinces: "provinces"
    })
  },
  methods: {
    ...mapActions(modules.area, {
      getProvinces: "getProvinces",
      getArea: "getArea"
    }),
    ...mapActions(modules.user, {
      getCompanySettingData: "getCompanySettingData",
      addCompanySetting: "addCompanySetting"
    }),
    //--营业执照
    // 图片上传之前-
    judgeImgLength(fileList) {
      console.log(123, fileList);
      // if (this.baseForm.images.length == 0) {
      //   this.fileList = this.defaultImg;
      // } else {
      if (fileList.length != this.baseForm.licensePhoto.length) {
        this.fileList = fileList.splice(1, 1);
      } else {
        this.fileList = fileList;
      }
      // }
    },
    handleChange(file, fileLis) {
      if (fileLis.length >= 1) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
      console.log(this.isShow);
    },
    handleChange1(file, fileLis) {
      if (fileLis.length >= 4) {
        this.hideUpload = true;
      } else {
        this.hideUpload = false;
      }
      console.log(this.hideUpload);
    },
    beforeUpload(file) {
      const isImg = file.type === "image/jpeg" || file.type === "image/png";
      const isLt500KB = file.size / 1024 / 1024 < 0.5;
      if (!isImg) {
        this.$Alert.info({
          content: "上传图片只能是JPG/png格式!",
          duration: 3000,
          status: "error"
        });
        return isImg && isLt500KB;
      }
      if (!isLt500KB) {
        this.$Alert.info({
          content: "上传图片大小不能超过500kb!",
          duration: 3000,
          status: "error"
        });
        return isImg && isLt500KB;
      }
      // if (this.baseForm.licensePhoto.length == 1) {
      //   this.isShow = false;
      //   // this.$Alert.info({
      //   //   content: "最多上传四张图片",
      //   //   duration: 3000,
      //   //   status: "error"
      //   // });
      //   // return false;
      // } else {
      //   this.isShow = true;
      // }
    },
    // 文件上传成功
    handleSuccess(res, file, fileList) {
      console.log(11222, res, file, fileList);

      this.baseForm.licensePhoto.push(res.name);
      this.judgeImgLength(fileList);
    },
    // 文件移除
    handleRemove(file, fileList) {
      if (file.id) {
        this.index = this.baseForm.licensePhoto.indexOf(file.id);
      } else if (file.response) {
        this.index = this.baseForm.licensePhoto.indexOf(file.response.name);
      } else {
        let urlSlashCount = file.url.split("/").length; // 统计有3斜杠
        let str = file.url.split("/")[urlSlashCount - 1].toLowerCase(); //获取数组最后一个
        this.index = this.baseForm.licensePhoto.indexOf(str);
      }
      if (this.index != -1) {
        this.baseForm.licensePhoto.splice(this.index, 1);
        this.judgeImgLength(fileList);
      }
      if (fileList.length >= 1) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    //公司图片---

    judgeImgLength1(fileList) {
      // if (this.baseForm.images.length == 0) {
      //   this.fileList = this.defaultImg;
      // } else {
      if (fileList.length != this.baseForm.enterpriseImgList.length) {
        this.fileList1 = fileList.splice(1, 1);
      } else {
        this.fileList1 = fileList;
      }
      // }
    },
    // 图片上传之前--
    beforeUpload1(file) {
      const isImg = file.type === "image/jpeg" || file.type === "image/png";
      const isLt500KB = file.size / 1024 / 1024 < 0.5;
      if (!isImg) {
        this.$Alert.info({
          content: "上传图片只能是JPG/png格式!",
          duration: 3000,
          status: "error"
        });
        return isImg && isLt500KB;
      }
      if (!isLt500KB) {
        this.$Alert.info({
          content: "上传图片大小不能超过500kb!",
          duration: 3000,
          status: "error"
        });
        return isImg && isLt500KB;
      }
      if (this.baseForm.enterpriseImgList.length >= 4) {
        this.$Alert.info({
          content: "最多上传四张图片",
          duration: 3000,
          status: "error"
        });
        return false;
      }
    },
    // 文件上传成功
    handleSuccess1(res, file, fileList) {
      this.baseForm.enterpriseImgList.push(res.name);
      this.judgeImgLength1(fileList);
    },
    // 文件移除
    handleRemove1(file, fileList) {
      if (file.id) {
        this.index = this.baseForm.enterpriseImgList.indexOf(file.id);
      } else if (file.response) {
        this.index = this.baseForm.enterpriseImgList.indexOf(
          file.response.name
        );
      } else {
        let urlSlashCount = file.url.split("/").length; // 统计有3斜杠
        let str = file.url.split("/")[urlSlashCount - 1].toLowerCase(); //获取数组最后一个
        this.index = this.baseForm.enterpriseImgList.indexOf(str);
      }
      if (this.index != -1) {
        this.baseForm.enterpriseImgList.splice(this.index, 1);
        this.judgeImgLength1(fileList);
      }
      if (fileList.length >= 4) {
        this.hideUpload = true;
      } else {
        this.hideUpload = false;
      }
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      this.baseForm.imageName = file.response.name;
      console.log(222, this.imageUrl, file.response.name);
    },
    beforeAvatarUpload(file) {
      const isImg = file.type === "image/jpeg" || file.type === "image/png";
      const isLt500KB = file.size / 1024 / 1024 < 0.5;
      if (!isImg) {
        this.$message.error("上传图片只能是JPG/png格式!");
        return isImg && isLt500KB;
      }
      if (!isLt500KB) {
        this.$message.error("上传图片大小不能超过500kb!");
        return isImg && isLt500KB;
      }
    },
    //获取数据
    async getData() {
      let data = await this.getCompanySettingData();
      console.log("img", data.imageName);

      if (data.imageName != "") {
        this.imageUrl = this.uploadURl + "/" + data.imageName;
      }
      if (data.licensePhoto == null) {
        data.licensePhoto = [];
      }
      if (data.licensePhoto.length) {
        data.licensePhoto.forEach(ele => {
          this.fileList.push({
            name: ele,
            id: ele,
            url: this.uploadURl + "/" + ele
          });
          this.baseForm.licensePhoto.push(ele);
        });
        if (this.fileList.length >= 1) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      }
      if (data.enterpriseImgList == null) {
        data.enterpriseImgList = [];
      }
      if (data.enterpriseImgList.length) {
        data.enterpriseImgList.forEach(ele => {
          this.fileList1.push({
            name: ele,
            id: ele,
            url: this.uploadURl1 + "/" + ele
          });
          this.baseForm.enterpriseImgList.push(ele);
        });
        if (this.fileList1.length >= 4) {
          this.hideUpload = true;
        } else {
          this.hideUpload = false;
        }
      }
      if (data.enterpriseShortName != null) {
        this.baseForm.enterpriseShortName = data.enterpriseShortName;
      } else {
        this.baseForm.enterpriseShortName = data.enterpriseName;
      }
      this.baseForm.enterpriseID = data.enterpriseID;
      this.baseForm.enterpriseName = data.enterpriseName;
      this.baseForm.scope = data.scope;
      this.baseForm.leader = data.leader;
      this.baseForm.phone = data.phone;
      this.baseForm.address = data.address;
      this.baseForm.remark = data.remark;
      this.baseForm.provinceNo = data.provinceId;
      await this.selectProvince();
      this.baseForm.cityNo = data.cityId;
      await this.selectCity();
      this.baseForm.countyNo = data.countryId;
      this.getProvinces();
    },
    //保存
    async saveData(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let obj = {
            enterpriseName: this.baseForm.enterpriseName,
            enterpriseShortName: this.baseForm.enterpriseShortName,
            areaId:
              this.baseForm.countyNo ||
              this.baseForm.cityNo ||
              this.baseForm.provinceNo,
            remark: this.baseForm.remark,
            imageName: this.baseForm.imageName,
            address: this.baseForm.address,
            licensePhoto: this.baseForm.licensePhoto,
            enterpriseImgList: this.baseForm.enterpriseImgList,
            scope: this.baseForm.scope
          };
          console.log(12222, obj.licensePhoto);
          this.loadingtype = true;
          this.addCompanySetting(obj)
            .then(rsp => {
              if (rsp.status === 200) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.loadingtype = false;
              }
            })
            .catch(err => {
              this.$message.error(err.response.data);
            });
        } else {
          return false;
        }
      });
    },
    //取消
    cancelForm() {
      history.go(-1);
    },
    //省份获取之后 获取对应的城市
    async selectProvince() {
      let obj = {
        parentNo: this.baseForm.provinceNo
      };
      let result = await this.getArea(obj);
      this.citys = result;
      this.baseForm.cityNo = null;
      this.baseForm.countyNo = null;
      this.countys = [];
    },
    // 城市获取之后 获取对应的县市
    async selectCity() {
      let obj = {
        parentNo: this.baseForm.cityNo
      };
      let result = await this.getArea(obj);
      this.countys = result;
      this.baseForm.countyNo = null;
    }
  }
};
</script>

<style lang="stylus">
.companySetting

  .hide .el-upload--picture-card 
    display: none;

  .el-upload-list--picture-card .el-upload-list__item,.el-upload--picture-card
    width:160px;
    height:148px;
  .el-icon-plus
    position relative
    display block
    width:160px;
    height:148px;
    .upload-tip
      min-width 130px;
      text-align center;
      position absolute;
      top:55%;
      font-size:14px;
      padding:0 15px;
      line-height 1.4;
  .el-icon-plus:before
    position absolute;
    content: "";
    top:30%;
    left 50%;
    margin-top:-24px;
    margin-left:-24px;
    width: 48px;
    height: 48px;
    background: url(../../../../assets/images/qualityTracing/input_add.png) no-repeat center center;
    background-size: 48px 48px;
  .el-upload--picture-card
    float left 
    margin-right 10px;
  .upload-tip
    position absolute
    top:150px;
    font-size:14px;
  .el-input--medium .el-input__inner 
    height: 44px;
    line-height: 40px;
    font-size:14px;
    font-family:MicrosoftYaHeiUI;
    font-weight:400;
    color:rgba(51,51,51,1);
  
  .el-form
    margin-left:120px;
    .imgLogo .el-form-item__label
      margin-top:15px;
    .el-form-item .el-form-item__label:before
      position: absolute;
      top: 2px;
      left: 10px;
      color: #fe3223;
    .el-form-item__label
      text-align right;
      font-size:14px;
      font-family:MicrosoftYaHei;
      font-weight:400;
      color:rgba(102,102,102,1);
      margin-left:-15px;
    
    
  textarea
    font-size:14px;
    font-family:MicrosoftYaHeiUI;
    font-weight:400;
    color:rgba(51,51,51,1);
    min-height:180px !important;
    width: 500px !important
  .avatar-uploader
    position relative;
    margin-bottom:18px;
    img
      width:72px;
      height:72px;
      border-radius:50%;
    span 
      position absolute;
      top:75px;
      text-decoration underline;
      left:10px;
      background:rgba(255,255,255,0.01);
      border-color: #fff;
      color:#409EFF;
  .save-btn .el-button
    margin-left:-12px!important;

      

</style>
